(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.IEMessaging = {
    attach: function attach(context, settings) {
      var message_viewed = window.sessionStorage.getItem("ie_message_viewed");

      var supportsES6 = function () {
        try {
          new Function("(a = 0) => a");
          return true;
        } catch (err) {
          return false;
        }
      }();

      var isLegacyEdge = /Edge./i.test(navigator.userAgent) ? true : false;

      if ((!supportsES6 || isLegacyEdge) && !message_viewed) {
        $(".ie-message").addClass("show");
        $(".farmers-logo-svg").css("margin-top", "72px");
      }

      function ie_message_close() {
        $(".ie-message").hide();
        viewed_message();
      }

      window.ie_message_close = ie_message_close;

      function viewed_message() {
        sessionStorage.setItem("ie_message_viewed", true);
        $(".farmers-logo-svg").css("margin-top", "");
      }

      window.viewed_message = viewed_message;
    }
  };
})(jQuery, Drupal, drupalSettings);

},{}]},{},[1]);
